import { Input } from 'antd';
import React, { useState, useEffect } from 'react';

const PercentageInput = ({ value, onChange, disabled }) => {
  const [inputValue, setInputValue] = useState('');

  useEffect(() => {
    if (typeof value === 'number' && !isNaN(value)) {
      const percentage = (value * 100).toFixed(2);
      setInputValue(formatDisplayValue(percentage));
    } else {
      setInputValue('');
    }
  }, [value]);

  const formatDisplayValue = (numString) => {
    const [intPart, decPart = ''] = numString.split('.');
    const decimal = decPart.padEnd(2, '0').slice(0, 2);
    return `${intPart},${decimal}`;
  };

  const handleChange = (e) => {
    const raw = e.target.value.replace(/\D/g, '');
    if (raw.length === 0) {
      setInputValue('');
      return;
    }

    let int = raw.slice(0, -2);
    let decimal = raw.slice(-2);

    if (int === '') int = '0';
    const formatted = `${parseInt(int, 10)},${decimal}`;
    setInputValue(formatted);
  };

  const handleBlur = () => {
    const normalized = inputValue.replace(',', '.');
    const parsed = parseFloat(normalized);
    const final = isNaN(parsed) ? undefined : parsed / 100;
    onChange(final);
  };

  return <Input disabled={disabled} value={inputValue} onChange={handleChange} onBlur={handleBlur} placeholder="0,00" suffix="%" maxLength={6} />;
};

export { PercentageInput };
